import React, { useState } from "react";
import { fetchCompany }from "./Services/fetchCompany";
import { fetchCompanyByDate }from "./Services/fetchCompany";
import { updateCompanyStatus} from "./Services/updateCompany";
import { deleteCompanyById} from "./Services/DeleteCompanyById";
import {CompanyModuleService} from "./Services/companyModuleService";
import {CompanyNotiService} from "./Services/companyNotiService";
import {useEffect} from "react";
import { useNavigate } from 'react-router-dom';
const ViewCompany = () => {
     useEffect(() => {
        const scriptUrls = [
        'assets/js/jquery.min.js',
        'assets/js/bootstrap.bundle.min.js',
        'assets/js/moment.min.js',
        'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
        'assets/vendor/overlay-scroll/custom-scrollbar.js',
        'assets/vendor/daterange/daterange.js',
        'assets/vendor/daterange/custom-daterange.js',
        'assets/vendor/datatables/dataTables.min.js',
        'assets/vendor/datatables/dataTables.bootstrap.min.js',
        'assets/vendor/datatables/custom/custom-datatables.js',
        'assets/js/custom.js'
  ];
    
        let isCancelled = false;
    
        // Load scripts sequentially
        const loadScriptsSequentially = async () => {
          for (const url of scriptUrls) {
            if (isCancelled) break;
    
            await new Promise((resolve, reject) => {
              const script = document.createElement('script');
              script.src = url;
              script.onload = resolve;
              script.onerror = reject;
              document.body.appendChild(script);
            });
          }
          const $ = window.jQuery;
          const input = $('#abc');
      
          if (input.length > 0) {
            input.on('apply.daterangepicker', function (ev, picker) {
              const value = input.val();
              handleDateChange(value);
            });
          }
        };
    
        loadScriptsSequentially();
    
        return () => {
          const $ = window.jQuery;
    if ($) {
      $('#abc').off('apply.daterangepicker');
    }
          isCancelled = true;
          // Optionally remove scripts if needed
        };
      }, []);
    const [companies, setCompanies] = useState([]);
    const getCompanies =()=> {
        const fetch = async () => {
          const data = await fetchCompany();
          setCompanies(data);
        };
        fetch();
      }
      useEffect(()=>{
    
        getCompanies();
      }, []);
     
       
      const [activate,setActivate]=useState(false);
     const handleActivate = async (id,active) => {
       await updateCompanyStatus(id,{isActive: active});
       await updateCompanyStatus(id,{isActive: active});
       getCompanies();
     };
   const [delId,setDelId]=useState(null);
     const handleDelete = async (id) => {
       await deleteCompanyById(id);
       await CompanyModuleService.updateDeletedFlags(id);
       await CompanyNotiService.updateDeletedFlags(id);
       getCompanies();
     };
   /*   useEffect(() => {
      const jQuery = window.jQuery;
      const input = jQuery ? jQuery('#abc') : null;
    
      if (input && input.length > 0) {
        input.on('apply.daterangepicker', function (ev, picker) {
          const value = input.val();
          handleDateChange(value);
        });
      }
    
      return () => {
        if (input && input.length > 0) {
          input.off('apply.daterangepicker');
        }
      };
    }, []); */
    
    
      const [dateRange, setDateRange] = useState({
        fromDate: "",
        toDate: "",
      });
      const handleDateChange = async (value) => {
        if (!value) return;
        const [from, to] = value.split(" - ");
    
        setDateRange({
          fromDate: from,
          toDate: to,
        });
    
        try {
          const fetch = async () => {
          const data = await fetchCompanyByDate(from, to);
          setCompanies(data); // You can display this in a table, etc.
          console.log("Companies fetched:", data);
          };
          fetch();
          
        } catch (error) {
          console.error("Failed to fetch companies:", error);
          
        }
      };
      
    const navigate =useNavigate('');
      const handleCompanyLogin = async (comEmail,rolId,comId,acti) => {
        if(acti==='Y'){
          // Save auth data or token for this company
          sessionStorage.removeItem('email');
          sessionStorage.setItem('email', comEmail);
          sessionStorage.setItem('rolls', rolId);
          sessionStorage.setItem('comid', comId);
          // Optional: Update global state or context if you use Redux or Context API
      
          // Redirect to company dashboard
          navigate('/company-dashboard');
          window.location.reload();
        }else {
          alert('Company is deactivated.');
        }
       
      };
      
  return(   
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="#!">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        View/Actions on Company
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
      <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" 
        />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            {/* Custom tabs starts */}
            <div className="custom-tabs-container">
              {/* Nav tabs starts */}
             
              {/* Nav tabs ends */}
              {/* Tab content starts */}
              <div className="tab-content h-350">
             
                <div className="tab-pane fade show active" id="fourA" role="tabpanel">
                <div className="row gx-4">
                    <div className="col-12">
                      <div className="table-outer mb-3">
                      {companies.length>0&&(<div className="table-responsive">
                          <table className="table truncate align-middle m-0">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Comapny Name</th>
                                <th>Contact Person</th>
                                <th>Contact No</th>
                                <th>Type</th>
                                <th>Login</th>
                                <th>Renew</th>
                                <th>Status</th>
                                <th>Delete</th>
                              </tr>
                            </thead>

                            <tbody>

                              {companies.map((com,index)=>(
                                 <tr key={com.companyId}>
                                 <td>#{index + 1}</td>
                                 <td>{com.companyName}</td>
                                 <td>
                                   {com.primaryPerson}
                                 </td>
                                 <td>{com.phoneNumber}</td>
                                 <td>{com.companyTypeName}</td>
                                 <td><a href={"/dashboard-company"} className="text-primary"
                                  onClick={() => handleCompanyLogin(com.emailAddress,1012,com.companyId,com.isActive)} action>Login</a></td>
                                 <td><div className="form-check form-switch m-0">
                                     <input className="form-check-input" type="checkbox" role="switch" id="cardActive"  defaultChecked/>
                                   </div></td>
                                 <td>
                                   <div className="form-check form-switch m-0">
                                     <input className="form-check-input" type="checkbox" role="switch" id="cardActive"
                                     defaultChecked={com.isActive === 'Y' ? true : false}
                                     onChange={(e) => {
                                       if(com.isActive==='Y'){
                                        handleActivate(com.companyId,'N');
                                       }else{
                                        handleActivate(com.companyId,'Y');
                                       }
                                     }}
                                     
                                     defaultChecked={com.isActive === 'Y' ? true : false}
                                     onChange={(e) => {
                                       if(com.isActive==='Y'){
                                        handleActivate(com.companyId,'N');
                                       }else{
                                        handleActivate(com.companyId,'Y');
                                       }
                                     }}
                                     
                                        />
                                   </div>
                                 </td>
                                 <td>
                                   <div className="form-check form-switch m-0">
                                     <input className="form-check-input" type="checkbox" role="switch" id="cardActive"
                                      data-bs-toggle="modal"
                                      data-bs-target="#delRow"
                                      value={com.deleted} onChange={() =>setDelId(com.companyId)}
                                      defaultChecked={com.deleted}/>
                                   </div>
                                 </td>
                               </tr>
                              ))}
                             
                             {companies.length===0 &&(
                              <tr>
                              <td colSpan="4" className="text-center">
                                No Roles found.
                              </td>
                            </tr>
                             )}
                            </tbody>
                            {/* <tbody>
                              <tr>
                                <td>Lilavati Hospital</td>
                                <td>
                                  Mukesh Chandra
                                </td>
                                <td>7856457890</td>
                                <td>Superspeciality Hospital</td>
                                <td><div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div></td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Curis Hospital</td>
                                <td>
                                  Ramesh Chandra
                                </td>
                                <td>7856457898</td>
                                <td>Superspeciality Hospital</td>
                                <td><div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div></td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Maya Hospital</td>
                                <td>
                                  Nishant Paul
                                </td>
                                <td>7856457896</td>
                                <td>Superspeciality Hospital</td>
                                <td><div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div></td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>Somavati Hospital</td>
                                <td>
                                  Sohan Chandra
                                </td>
                                <td>7856457891</td>
                                <td>Speciality Hospital</td>
                                <td><div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div></td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check form-switch m-0">
                                    <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                                  </div>
                                </td>
                              </tr>
                             
                            </tbody> */}
                          </table>
                        </div>)}
                        <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="delRowLabel">
            Confirm
          </h5>
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body">
          Are you sure you want to delete the Company from list?
        </div>
        <div className="modal-footer">
          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
            <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" 
            onClick={() => handleDelete(delId)}>Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>

                      </div>
                    </div>
                                
                  </div>
                </div>
                
              </div>
              {/* Tab content ends */}
            </div>
            {/* Custom tabs ends */}
            {/* Buttons starts */}
            
            {/* Buttons ends */}
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>


  );
}
export default ViewCompany;




